export default class LiveTVAvailabilityResponse {
    constructor(resp) {
        this.logos = null
        this.message = null
        this.stations = null
        this.scheduleUrls = null
        this.media = null
        this.market = null
        this.label = null;

        Object.assign(this, resp)
    }
}
